import { getFiles } from '../services/napi';
import { FILES_FETCH_SUCCESS, FILES_FETCH_FAIL } from '../constant/actionType';

function fetchFilesSuccess(data) {
  return { data, type: FILES_FETCH_SUCCESS };
}

function fetchFilesError() {
  return {
    error: 'FILES_FETCH_FAIL',
    type: FILES_FETCH_FAIL
  };
}

export function fetchFiles() {
  return async (dispatch, getState) => {
    try {
      const { _id: projectId } = getState().project.currentProject;

      const response = await getFiles(projectId);

      dispatch(fetchFilesSuccess(response.data));
    } catch (error) {
      dispatch(fetchFilesError());
    }
  };
}
